import { createFileRoute } from "@tanstack/react-router";
import { AssetGroupAssets } from "@/components/Map/components/AssetGroupAssets";

export const Route = createFileRoute("/_auth/kart/assetGroup/$assetGroupName/assets")({
  component: AssetGroupAssets,
});
